import { PanelState } from "@/types/ui";
import { CSSSelector, SelectorCSSName } from "./selectors";
import { BreakdanceDocumentWithExportedTree } from "./document";
import { PropertiesData, TreeNode } from "./tree";
import { ElementPreset } from "./presets";
import { Variable } from "@/oxygen/variables/lib/types";
import { OxySelector } from "@/oxygen/classes/lib/types";
import { InlineEditingContext } from "@/types/inline-editor";

export enum SnapshotLabelAction {
  CHANGE = "Change",
  DELETE = "Delete",
  COPY = "Copy",
  PASTE = "Paste",
  CLEAR = "Clear",
  DUPLICATE = "Duplicate"
}

export type SnapshotLabelActionAndSubject = {
  action: SnapshotLabelAction;
  subject: string;
};

export type SnapshotOptionalInfo = {
  key?: string | undefined;
  title?: string | undefined;
};

export type SnapshotInfo = SnapshotOptionalInfo & {
  id: number;
};

export type BuilderSnapshotData = SnapshotOptionalInfo & {
  document: BreakdanceDocumentWithExportedTree;
  globalSettings: PropertiesData;
  cssSelectors: CSSSelector[];
  presets: ElementPreset[];
  variables: {
    variables: Variable[];
    collections: string[];
  };
  oxySelectors: {
    selectors: OxySelector[];
    collections: string[];
  };
  activeElementId: null | TreeNode["id"];
  activeSelectorName: null | SelectorCSSName;
  panelState: PanelState;
  inlineEditingContext: null | InlineEditingContext;
};

export type BrowseModeSnapshotData = Omit<
  BuilderSnapshotData,
  "document" | "activeElementId" | "inlineEditingContext"
>;

export type SnapshotData = BuilderSnapshotData | BrowseModeSnapshotData;

export type TakeBuilderSnapshotArgs = BuilderSnapshotData & {
  title: string;
};

export type TakeBrowseModeSnapshotArgs = BrowseModeSnapshotData & {
  title: string;
};
